<template>
  <div class="addApprover-box">
    <div class="content">
      <div @click="chooseApprover" class="search-box">{{toApproverName}}</div>
      <div class="selected-box">
        <div v-for="(item,index) in chooseApproverList" :key="index" class="selected-item">
          <img v-if="item.avatar!=null||item.avatar!=''" class="headimg" :src="item.avatar" />
          <img v-else class="headimg" :src="require('@/assets/images/defaultHead.png')" />
          <label>{{item.name}}</label>
          <img
            @click="deleteChooseApprover(index)"
            class="delete-bnt"
            src="../../../assets/icon/icon-guanbi.png"
          />
        </div>
      </div>
      <div v-if="chooseApproverList.length>1" class="approvalWay-box">
        <div class="label-box">审批方式</div>
        <div class="choose-box">
          <label @click="chooseApprovalWay">{{approvalWayText}}</label>
          <img
            v-if="saveData.approveWay<=-1"
            @click="chooseApprovalWay"
            src="../../../assets/icon/arrowright.png"
          />
        </div>
      </div>
    </div>
    <div @click="saveApproverData" class="bnt-box">
      <div class="add-bnt">添加</div>
    </div>
  </div>
</template>
<script>
import * as dd from "dingtalk-jsapi";
import { mapState } from "vuex";
import http from "@/utils/http";
import { promised } from "q";
const { menuItem } = require(`@/config/develop.json`);
export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      dingdingconfig: state => state.dingdingconfig
    }),
    toApproverName: function() {
      let str = "";
      this.chooseApproverList.forEach(item => {
        str += item.name + ",";
      });
      var reg = /,$/gi;
      return str.replace(reg, "");
    },
    toDisabledUsers: function() {
      return this.chooseApproverList.map(item => {
        return item.emplId;
      });
    }
  },
  data() {
    return {
      approvalWayText: "请选择",
      chooseApproverList: [],
      saveData: {}
    };
  },
  methods: {
    deleteChooseApprover(index) {
      this.chooseApproverList.splice(index, 1);
    },
    chooseApprover() {
      this.complexChoose().then(users => {
        this.chooseApproverList.push(...users);
      });
    },
    chooseApprovalWay() {
      let _this = this;
      dd.device.notification.actionSheet({
        title: "选择审批方式", //标题
        cancelButton: "取消", //取消按钮文本
        otherButtons: ["或签", "会签"],
        onSuccess: function(result) {
          console.log(result);
          if (result.buttonIndex > -1) {
            _this.saveData.approveWay = result.buttonIndex;
            _this.approvalWayText = result.buttonIndex == 0 ? "或签" : "会签";
          }
        },
        onFail: function(err) {}
      });
    },
    complexChoose() {
      let _this = this;
      return new Promise(function(resolve, reject) {
        dd.biz.contact.complexPicker({
          title: "选择员工", //标题
          corpId: _this.dingdingconfig.corpId, //企业的corpId
          multiple: true, //是否多选
          limitTips: "超出了", //超过限定人数返回提示
          maxUsers: 50, //最大可选人数
          pickedUsers: [], //已选用户
          pickedDepartments: [], //已选部门
          disabledUsers: _this.toDisabledUsers, //不可选用户
          disabledDepartments: [], //不可选部门
          requiredUsers: [], //必选用户（不可取消选中状态）
          requiredDepartments: [], //必选部门（不可取消选中状态）
          appId: _this.dingdingconfig.agentId, //微应用的Id
          permissionType: "GLOBAL", //可添加权限校验，选人权限，目前只有GLOBAL这个参数
          responseUserOnly: true, //返回人，或者返回人和部门
          startWithDepartmentId: -1, //仅支持0和-1
          onSuccess: function(result) {
            result.users.forEach(item => {
              item.userId = item.emplId;
            });
            resolve(result.users);
          },
          onFail: function(err) {
            resolve({});
          }
        });
      });
    },
    saveApproverData() {
      this.saveData.dingUserId = this.toDisabledUsers.join();
      if (this.toDisabledUsers.length > 0) {
        if (this.toDisabledUsers.length > 1 && this.saveData.approveWay < 0) {
          this.$Spin.hide();
          dd.device.notification.alert({
            message: "请选择审批方式",
            title: "提示", //可传空
            buttonName: "确认",
            onSuccess: function() {
              //onSuccess将在点击button之后回调
              /*回调*/
            },
            onFail: function(err) {}
          });
        } else {
          if (this.saveData.approveWay < 0) {
            this.saveData.approveWay = 1;
          }
          this.$Spin.show();
          this.createApprover().then(res => {
            if (res) {
              this.$router.go(-1);
            }
          });
        }
      } else {
        this.$Message["error"]({
          background: true,
          content: "请选择审批人"
        });
      }
    },
    createApprover() {
      let _this = this;
      var item = menuItem[this.saveData.applyTypeId];
      return new Promise(function(resolve, reject) {
        if (item) {
          http({
            method: "post",
            url: `/api${item}/CreateApprover`,
            data: _this.saveData
          }).then(res => {
            _this.$Spin.hide();
            resolve(res.data);
          });
        } else resolve(false);
      });
    }
  },
  mounted() {
    this.saveData = {
      ...this.$route.query,
      dingUserId: "",
      approveWay: -1,
      createUserId: this.userInfo.employeeID
    };
  }
};
</script>
<style lang="less" scoped>
.addApprover-box {
  width: 100%;
  height: 100%;
  padding: 0 0.4rem;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    .search-box {
      margin-top: 30px;
      width: 100%;
      height: 1.066667rem;
      line-height: 1.066667rem;
      background: #f5f5f5;
      border-radius: 0.533333rem;
      font-size: 0.426667rem;
      color: #333;
      padding: 0 0.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .search-box:empty:before {
      content: "选择审批人";
      color: gray;
    }
    .selected-box {
      margin-top: 0.4rem;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      .selected-item {
        height: 0.8rem;
        line-height: 0.8rem;
        margin-right: 0.6rem;
        font-size: 0.346667rem;
        img {
          vertical-align: middle;
        }
        .headimg {
          width: 0.533333rem;
          height: 0.533333rem;
          margin-right: 0.133333rem;
          border-radius: 50%;
        }
        label {
          vertical-align: middle;
        }
        .delete-bnt {
          width: 0.2rem;
          height: 0.2rem;
        }
      }
    }
    .approvalWay-box {
      height: 1.44rem;
      line-height: 1.44rem;
      display: flex;
      font-size: 0.373333rem;
      .label-box {
        width: 2.493333rem;
      }
      .choose-box {
        flex: 1;
        text-align: right;
        color: #999;
        img {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
    }
  }
  .bnt-box {
    width: 100%;
    height: 1.6rem;
    line-height: 1.6rem;

    .add-bnt {
      width: 100%;
      height: 0.96rem;
      line-height: 0.96rem;
      text-align: center;
      background-image: linear-gradient(121deg, #ffd10a 0%, #ff9e07 100%);
      border-radius: 0.533333rem;
      font-size: 0.426667rem;
      font-weight: bold;
      letter-spacing: 0.266667rem;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/AddApprover/index.vue